/* eslint-disable max-len */
import faq_message from "./message_faq_fr.js";
import privacy_message from "./message_privacy_fr.js";

export default {
  error: {
    apicall: 'Quelque chose s\'est mal passé sur le serveur api !',
    UserNotFoundException: 'L\'utilisateur n\'existe pas.',
    NotAuthorizedException: 'Nom d\'utilisateur ou mot de passe incorrect.',
    ChangePasswordNotAuthorizedException: 'Ancien mot de passe incorrect.',
    LimitExceededException: 'La limite de tentative a été dépassée, veuillez essayer après un certain temps.',
    UsernameExistsException: 'Un compte avec cette adresse email existe déjà.',
    InvalidParameterExceptionPassword: 'Le mot de passe ne respecte pas les exigences de complexité: le mot de passe doit contenir au minimum 8 caractères.',
    InvalidPasswordExceptionLong: 'Le mot de passe ne respecte pas les exigences de complexité: le mot de passe est trop court.',
    InvalidPasswordExceptionLower: 'Le mot de passe ne respecte pas les exigences de complexité: le mot de passe doit contenir au minimum une minuscule.',
    InvalidPasswordExceptionUpper: 'Le mot de passe ne respecte pas les exigences de complexité: le mot de passe doit contenir au minimum une majuscule.',
    InvalidPasswordExceptionNumeric: 'Le mot de passe ne respecte pas les exigences de complexité: le mot de passe doit contenir au minimum une chiffre.',
    InvalidPasswordExceptionSymbol: 'Le mot de passe ne respecte pas les exigences de complexité: le mot de passe doit contenir au minimum un des caractères spéciaux susmentionnés.',
    similar: 'Un utilisateur ayant le même nom et date de naissance existe déjà. Veuillez indiquer un commentaire pour le différencier.',
    alreadyAssignedImei: 'IMEI déjà assigné à un conducteur.',
    NetworkingError: 'Hum..., il semble que vous n\'êtes plus connecté à internet.',
  },
  accountMenu: {
    settings: 'Changement de mot de passe',
    logout: 'Déconnexion',
    language: 'Langue',
    languageFr: 'Français',
    languageNl: 'Nederlands',
    languageDe: 'Deutsch',
    languageEn: 'English',
  },
  login: {
    welcome1: 'Bienvenue dans le programme BRAKE "Behaviour Recording and Assessment for RisKs Education".',
    welcome2: 'Veuillez vous identifier pour accéder à vos données.',
    email: 'Email',
    emailPlaceholder: 'Entrez votre adresse email',
    password: 'Mot de passe',
    passwordPlaceholder: 'Entrez votre mot de passe',
    rememberMe: 'Se souvenir de moi',
    forgottenPassword: 'Oublié ?',
    connect: 'Se connecter',
    connectBussy: 'Connexion …',
    definePassword: 'Changez votre mot de passe',
    instructions: {
      title: 'Votre nouveau mot de passe doit contenir au moins:',
      characters: 'caractères',
      uppercase: 'majuscule',
      number: 'nombre',
      symbol: 'caractère spécial',
    },
    definePasswordButton: 'Changez de mot de passe',
    definePasswordButtonBussy: 'Changement de mot de passe...',
  },
  signup: {
    emailLabel: 'Email',
    emailPlaceholder: 'Indiquez votre adresse email',
    passwordLabel: 'Choisir un mot de passe',
    passwordPlaceholder: 'Choisissez un mot de passe',
    confirmPasswordLabel: 'Confirmation mot de passe',
    confirmPasswordPlaceholder: 'Entrez le mot de passe à nouveau',
    confirmationCodeLabel: 'Code de vérification',
    confirmationCodePlaceholder: 'Entrez le code de vérification',
    confirmationCodeHelp: 'Veuillez vérifier vos emails. Vous allez recevoir un code de confirmation.',
    registerButton: 'Confirmer',
    registerBussy: 'Enregistrement …',
    allreadyAccountQuestion: 'Vous possedez déjà un compte VIAS BRAKE ?',
    connectHere: 'Connectez vous ici',
    oldPasswordPlaceholder: 'Introduisez votre ancien mot de passe.',
    oldPasswordLabel: 'Ancien mot de passe',
  },
  forgot: {
    reinitPassword: 'Réinitialiser le mot de passe',
    mailsent: 'Email envoyé',
    anEmailHasBeenSent: 'Un email vous a été envoyé.',
  },
  menu: {
    title: {
      driversShort: 'Conducteurs',
      drivers: 'Conducteurs assignés',
      users: 'Gestion des utilisateurs',
      calendar: 'Calendrier',
      contested: 'Contestations',
    },
  },
  adminDashboard: {
    tabs: {
      drivers: 'Conducteurs',
      psychologists: 'Psychologues',
      admins: 'Administrateurs',
    },
    users: {
      firstName: 'Prénom',
      lastName: 'Nom',
      birthdate: 'Date de naissance',
      email: 'Adresse email',
      comment: 'Commentaire',
      search: 'Recherche',
      new: 'Nouveau',
      edit: 'Editer',
      delete: 'Supprimer',
      confirmDeleteTitle: 'Etes vous sur de vouloir supprimer?',
      deleteOk: 'Confirmer',
      deleteCancel: 'Annuler',
      clickEnterComment: 'Introduire un commentaire.',
    },
    drivers: {
      birthdate: 'Date de naissance',
      psychologist: 'Psychologue',
      imei: 'IMEI',
    },
    psychologist: {
      assigned: 'Nbr de conducteurs assignés',
      drivers: 'conducteur(s)',
    },
  },
  driverActions: {
    tabs: {
      calendar: 'Calendrier',
      stats: 'Statistiques',
      errorManagement: 'Dépassements de vitesses contestés',
      followUp: 'Objectifs et suivi',
    },
  },
  calendar: {
    event: {
      plugged: 'Boîtier branché',
      unplugged: 'Boîtier débranché',
    },
    messages: {
      date: 'Date',
      time: 'Heure',
      event: 'Rendez-vous',
      allDay: 'toute la journée',
      week: 'semaine',
      work_week: 'semaine de travail',
      day: 'jour',
      month: 'mois',
      previous: 'précédent',
      next: 'suivant',
      yesterday: 'hier',
      tomorrow: 'demain',
      today: 'aujourd\'hui',
      agenda: 'agenda',
      more: 'en plus',
    },
  },
  driverSelection: {
    name: 'Nom',
    birthdate: 'Date de naissance',
    lastConsultation: 'Dernière consultation',
    disconnected: 'Déconnexions',
    constested: 'Contestations',
    speeding: 'Excès de vitesse',
  },
  contested: {
    date: 'Date',
    driver: 'Conducteur',
    location: 'Lieu',
    action: 'Action',
    errorType: 'Type d\'erreur',
    errorReason: 'Justification',
  },
  faq:{
    faq_message
  },
  privacy:{
    privacy_message
  },
  journeyDetails: {
    indexTitle: 'Trajet {index} sur {total}',
    speeding: 'Dépassements de vitesse',
    severityTitle: 'Gravité',
    severity: {
      noOverSpeed: 'Pas de dépassement de vitesse',
      small: 'Petite',
      medium: 'Moyenne',
      large: 'Grave',
      xlarge: 'Très grave',
    },
    speed: 'Vitesse',
    limit: 'Limitation',
    time: 'Heure',
    duration: 'Durée du segment',
    street: 'Rue',
    gps: 'GPS',
    reportError: 'Indiquer une erreur',
    acceptError: 'Accepter',
    rejectError: 'Rejeter',
    overspeed: 'Vitesse excédentaire',
    parameter: {
      start: 'Heure de départ',
      end: 'Heure d\'arrivée',
      distance: 'Distance parcourue',
      avgSpeed: 'Vitesse moyenne',
      maxSpeed: 'Vitesse max.',
    },
    itemsSelected: '{value, plural, one {élément selectionné} other {éléments selectionnés}}',
  },
  contestDialog: {
    title: 'Indiquer une erreur',
    errorType: 'Type d\'erreur',
    selectErrorType: 'Selectionnez le type d\'erreur',
    errorTypes: {
      mapmatching: 'Map matching erroné',
      cartography: 'Erreur cartographique',
      speedlimit: 'Limitation de vitesse erronée',
      other: 'Autre',
    },
    reason: 'Justification',
    forValidation: 'Pour validation',
    retour: 'Retour',
  },
  stats: {
    period: {
      overall: 'Tout',
      today: 'Aujourd\'hui',
      yesterday: 'Hier',
      currentWeek: 'Semaine en cours',
      lastWeek: 'Semaine dernière',
      currentMonth: 'Mois en cours',
      lastMonth: 'Mois dernier',
    },
    behaviour: {
      accelerations: 'Accélérations brutales',
      brakings: 'Freinages brusques',
    },
    grouping: {
      dayly: 'Journalière',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuelle',
      dayOfWeek: 'Jours de la semaine',
      hourOfDay: 'Heures de la journée',
      groupOfHourOfDay: 'Heures groupées de la journée',
      limit: 'Par limitation de vitesse',
    },
    charts: {
      numberOfOverspeeds: 'Nbre de dépassements de vitesse',
      numberOfEvents: 'Nbre d\'évènements',
      totalOverspeeds: {
        title: 'Total dépassements',
      },
      overspeedsBySeverity: {
        title: 'Détails gravité',
      },
      totalOverspeedsBySeverity: {
        title: 'Total gravité',
      },
      behaviourChart: {
        title: 'Freinages / accélérations',
      },
    },
  },
  followUp: {
    buttons: {
      new: 'Nouveau',
      save: 'Enregistrer',
      cancel: 'Annuler',
    },
    comment: 'Commentaires',
    commentPlaceholder: 'Veuillez introduire les commentaires relatif au conducteur ici.',
    objective: 'Objectifs',
    objectivePlaceholder: 'Veuillez introduire les objectifs ici.',
  },
  'react-intl-formatted-duration': {
    duration: '{value} {unit}',
    longFormatting: '{minutes} {seconds}',
    timerFormatting: '{minutes}:{seconds}',
    daysUnit: '{value, plural, one {jour} other {jours}}',
    hoursUnit: '{value, plural, one {heure} other {heures}}',
    minutesUnit: '{value, plural, one {minute} other {minutes}}',
    secondsUnit: '{value, plural, one {seconde} other {secondes}}',
  },
};



// WEBPACK FOOTER //
// ./src/messages_fr.js